import React from 'react';

const Logo = () => (
  <svg id="Logo_White" data-name="Logo White" xmlns="http://www.w3.org/2000/svg" width="194" height="89" viewBox="0 0 194 89">
    <text id="TREND" transform="translate(0 67)" fill="#fff" fontSize="64" fontFamily="Poppins-Black, Poppins" fontWeight="800" letterSpacing="-0.087em"><tspan x="0" y="0">TREND</tspan></text>
  </svg>
);

export default Logo;